import { render, staticRenderFns } from "./CustomSelectableIcons.vue?vue&type=template&id=94735526&"
import script from "./CustomSelectableIcons.vue?vue&type=script&lang=js&"
export * from "./CustomSelectableIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports